import client from './client.js';

// El plano del salón. Se dibuja desde el dashboard; el POS solo lo lee.
export const getTables = (params) =>
  client.get('/tables', { params }).then((r) => r.data);

export const getTableZones = () =>
  client.get('/tables/zones').then((r) => r.data);

// Ocupar es idempotente para la MISMA cuenta: mandar el total actualizado no
// se lee como choque. Si otra cuenta ya la trae, el backend responde 409.
export const occupyTable = (tableId, snapshot) =>
  client.post(`/tables/${tableId}/occupy`, snapshot).then((r) => r.data);

// Liberar exige el tab_id: así una tablet desincronizada no tira la cuenta
// nueva que alguien más abrió en esa mesa.
export const freeTable = (tableId, tabId) =>
  client.post(`/tables/${tableId}/free`, { tab_id: tabId }).then((r) => r.data);
